import { Spin } from "antd";
import { SpinProps } from "antd/es/spin";
import classNames from "classnames";
import { omit } from "lodash";

type CenterSpinnerResult = SpinProps & {
  whitelabel?: boolean;
};

export const CenterSpinner: React.FC<CenterSpinnerResult> = (props) => {
  const { whitelabel } = props;
  const spinProps = omit(props, ["whitelabel"]);

  const classes = classNames("verticalCenterWrapper", {
    whitelabel: whitelabel,
  });

  return (
    <div className={classes} style={{ width: "100%" }}>
      <Spin {...spinProps} />
    </div>
  );
};
